<!-- Footer -->
<footer class="site-footer">
  <div class="reusable-container">
    <div class="footer-grid">
      <!-- Brand -->
      <div class="footer-brand">
        <div class="brand-row">
          <div class="emblem">
            <img src="assets/images/emblem.png" alt="United Republic of Tanzania" />
          </div>
          <div class="brand-text">
            <div class="brand-small">The United Republic of Tanzania</div>
            <div class="brand-title">e-Mikutano</div>
          </div>
        </div>
        <p class="brand-copy">
          Tanzania's digital communication system for public institutions.
          Built, hosted, and operated by the e-Government Authority.
        </p>
        <div class="socials">
          <a class="social" href="#" aria-label="Twitter"><mat-icon svgIcon="twitter"></mat-icon></a>
          <a class="social" href="#" aria-label="Facebook"><mat-icon svgIcon="facebook"></mat-icon></a>
          <a class="social" href="#" aria-label="Instagram"><mat-icon svgIcon="instagram"></mat-icon></a>
          <a class="social" href="#" aria-label="LinkedIn"><mat-icon svgIcon="linked_in"></mat-icon></a>
        </div>
      </div>

      <!-- Product -->
      <div class="footer-col">
        <div class="col-head">Product</div>
        <ul>
          <li><a href="/#features">Features</a></li>
          <li><a routerLink="/auth/join-meeting">Join Meeting</a></li>
          <li><a href="#">Reservations</a></li>
          <li><a href="#">Mobile Apps</a></li>
          <li><a href="#">What's New</a></li>
        </ul>
      </div>

      <!-- Resources -->
      <div class="footer-col">
        <div class="col-head">Resources</div>
        <ul>
          <li><a href="#">User Manual</a></li>
          <li><a href="#">Help Center</a></li>
          <li><a href="#">API Docs</a></li>
          <li><a href="#">System Status</a></li>
          <li><a href="#">Changelog</a></li>
        </ul>
      </div>

      <!-- Institution -->
      <div class="footer-col">
        <div class="col-head">For Institutions</div>
        <ul>
          <li><a href="#">Request Access</a></li>
          <li><a href="#">Branded Instances</a></li>
          <li><a href="#">Compliance</a></li>
          <li><a href="#">Security Overview</a></li>
          <li><a href="#">Contact Sales</a></li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="footer-col">
        <div class="col-head">Contact</div>
        <ul class="contact-list">
          <li>
            <mat-icon>place</mat-icon>
            <span>e-Government Authority</span>
          </li>
          <li>
            <mat-icon>mail</mat-icon>
            <a href="mailto:info@ega.go.tz">info&#64;ega.go.tz</a>
          </li>
          <li>
            <mat-icon>call</mat-icon>
            <a href="tel:+255262323220">+255 26 232 3220</a>
          </li>
        </ul>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="footer-bottom">
      <div class="copyright">
        © {{ year }} e-Government Authority. All rights reserved.
      </div>
      <div class="legal">
        <a href="#">Legal Notice</a>
        <a href="#">Terms &amp; Conditions</a>
        <a href="#">Privacy Policy</a>
        <a href="#">Accessibility</a>
      </div>
    </div>
  </div>
</footer>
